import { EventBus } from '@/assets/js/event-bus';

/**
 * Central manager for annotation hover geometry updates.
 * Manages a shared timeout across all annotation boxes.
 */
class AnnotationHoverManager {
  private geometryUpdateTimeout: number | null = null;

  constructor() {
    EventBus.on('annotation.hover.schedule-geometry-update', () => {
      this.scheduleGeometryUpdate();
    });

    EventBus.on('annotation.hover.cancel-geometry-update', () => {
      this.cancelGeometryUpdate();
    });
  }

  private scheduleGeometryUpdate() {
    if (this.geometryUpdateTimeout !== null) {
      clearTimeout(this.geometryUpdateTimeout);
    }

    this.geometryUpdateTimeout = window.setTimeout(() => {
      EventBus.emit('UI.position.annotations.delayed');
      this.geometryUpdateTimeout = null;
    }, 200); // allow for animations to complete
  }

  private cancelGeometryUpdate() {
    if (this.geometryUpdateTimeout !== null) {
      clearTimeout(this.geometryUpdateTimeout);
      this.geometryUpdateTimeout = null;
    }
  }
}

export const annotationHoverManager = new AnnotationHoverManager();
